export default "__VITE_ASSET__b3af33e1__"